import { IOrderCreationDto } from '../api'

const removeOrderCreationDto = (): boolean => {
    if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem('orderCreationDto')
        return true
    }
    return false
}

const popOrderCreationDto = (): IOrderCreationDto | null => {
    if (typeof sessionStorage !== 'undefined') {
        const orderCreationDto = JSON.parse(sessionStorage.getItem('orderCreationDto'))
        sessionStorage.removeItem('orderCreationDto')
        return orderCreationDto
    }
    return null
}

const saveOrderCreationDto = (orderCreationDto: IOrderCreationDto): boolean => {
    if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('orderCreationDto', JSON.stringify(orderCreationDto || null))
        return true
    }
    return false
}

const getOrderCreationDto = (): IOrderCreationDto | null => {
    return typeof sessionStorage !== 'undefined'
        ? JSON.parse(sessionStorage.getItem('orderCreationDto')) || null
        : null
}

const updateOrderCreationDto = (partialOrderCreationDto: Partial<IOrderCreationDto>): boolean => {
    const orderCreationDto = getOrderCreationDto()

    if (orderCreationDto) {
        saveOrderCreationDto({ ...orderCreationDto, ...partialOrderCreationDto })
        return true
    }
    return false
}

const getIsOrderCreationInProgress = (): boolean =>
    typeof sessionStorage !== 'undefined'
        ? Boolean(sessionStorage.getItem('orderCreationDto'))
        : null

export {
    updateOrderCreationDto,
    saveOrderCreationDto,
    getIsOrderCreationInProgress,
    getOrderCreationDto,
    popOrderCreationDto,
    removeOrderCreationDto,
}
